import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';

import { HttpService } from '../shared/core/http.service';
import { ViewingSessionModel } from './viewingsession.model';
import { tap, map, catchError } from 'rxjs/operators';



@Injectable()
export class DocumentService {
  private documentsUrl = new URL('documents', environment.apiUrl).toString();
  constructor(private _httpService: HttpService) { }

  getDocuments(): Observable<string[]> {
    return this._httpService.httpGet(this.documentsUrl).pipe(
        catchError((error: any) => throwError(() => error || 'Server error'))
    );
  }

  createViewingSessionForDocument(filename: string): Observable<any> {
    return this._httpService.httpPost(`${this.documentsUrl}/${filename}/beginViewing`, {}).pipe(
      map((data: any) => data.viewingSessionId),
      catchError((error: any) => throwError(() => error.message || error))
    );
  }

  errorCustomHandler(error: any): Observable<any> {
    if (error.status === 401 && error.url && error.url.endsWith('GenerateToken')) {
        return throwError(() => error || 'Server error');
    }
    if (error.status === 401) {
        console.log('Redirect to Home: Error 401 unauthorized');
        window.location.href = window.location.origin;
    }
    return throwError(() => error || 'Server error');
  }

  private handleError(error: any) {
      console.error('companyService.handleError(...() >>> There has been an error while calling api, error:', error);
      return throwError(() => error || 'Server error');
  }

  createViewingSession(filename: string): Observable<ViewingSessionModel> {
    return this._httpService.httpPost(`${this.documentsUrl}/${filename}/beginViewing`, {}).pipe(
        map((response: any) => this.mapViewingSession(response)),
        tap(data => data)
    );
  }

  mapViewingSession(response: any): ViewingSessionModel {
    let viewingSessionModel: ViewingSessionModel = new ViewingSessionModel();
    viewingSessionModel.viewingSessionId = response.viewingSessionId;
    return viewingSessionModel;
  }
}
